function insensitiveEqual(value1: any, value2: any): boolean {
  return value1.toString().trim().toLowerCase() === value2.toString().trim().toLowerCase();
}

function now(): number {
  return Math.floor(Date.now() / 1000);
}

function extractObject(from: any, targetKeys: string[]) {
  const object = {};

  for (const key of targetKeys) {
    object[key] = from[key];
  }

  return object;
}

export {
  insensitiveEqual,
  now,
  extractObject,
};
